// eslint-disable-next-line @typescript-eslint/no-explicit-any
const statusCode = (e: any) => e?.statusCode || e?.status || 0

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isUnauthorizedError = (e: any) => {
  return statusCode(e) === 401
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNetworkError = (e: any) => {
  return statusCode(e) === 0
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isClientError = (e: any) => {
  const code = statusCode(e)

  return isNetworkError(e) || (code >= 400 && code < 500)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNotFoundError = (e: any) => {
  return statusCode(e) === 404
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isServerError = (e: any) => {
  const code = statusCode(e)

  return code >= 500 && code < 600
}

// @deprecated
export class APIError extends Error {
  private _statusCode: number

  constructor(statusCode: number, message: string) {
    if (statusCode < 400 && statusCode !== 0) {
      console.warn(`status code ${statusCode} is not an API Error`)
    }
    super(message)
    this._statusCode = statusCode
  }

  get status(): number {
    return this._statusCode
  }

  get isUnauthorized(): boolean {
    return isUnauthorizedError(this)
  }

  get isNetworkError(): boolean {
    return isNetworkError(this)
  }

  get isClientError(): boolean {
    return isClientError(this)
  }

  get isServerError(): boolean {
    return isServerError(this)
  }
}

export class ErrorShouldBeIgnored extends Error {
  private _reason: string

  constructor(reason?: string) {
    super()
    this._reason = reason != null ? ` (reason: ${reason})` : ''
  }

  get message() {
    return `[dev] this error should be ignored${this._reason}. please handle properly.`
  }
}
